/**
 * Minimal test profile page for debugging routing issues
 */
import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const API = (() => {
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return "http://localhost:8001/api";
  return `https://api.${host}/api`;
})();

export default function TestProfile() {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/v2/people/${userId}`)
      .then(r => setData(r.data))
      .catch(e => setErr(e.message));
  }, [userId]);

  return (
    <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#fff', background: '#111', minHeight: '100vh' }}>
      <h1>Test Profile</h1>
      <p>Route param userId: <strong>{userId || 'NOT FOUND'}</strong></p>
      <p>API URL: {API}/v2/people/{userId}</p>
      {err && <p style={{ color: 'red' }}>Error: {err}</p>}
      {data && <pre style={{ background: '#222', padding: 16, borderRadius: 8 }}>{JSON.stringify(data, null, 2)}</pre>}
      {!data && !err && <p>Loading...</p>}
      <Link to="/people-directory" style={{ color: '#8b5cf6' }}>Back to People Hub</Link>
    </div>
  );
}
